import { assetPath } from "../lib/legacyPaths.js";
import { useI18n } from "../i18n.jsx";

const practiceLinks = [
  {
    label: "LineSpeak",
    href: "https://linespeak.app",
    icon: "/app-icons/linespeak.png"
  },
  {
    label: "Read Aloud",
    href: "https://pera-pera.org/apps/readaloud/",
    icon: "/app-icons/readaloud.svg"
  },
  {
    label: "Phrasal Verbs",
    href: "https://pera-pera.org/apps/phrasalverbs/",
    icon: "/app-icons/phrasal-verbs.jpg"
  },
  {
    label: "All Tools",
    href: "https://pera-pera.org/",
    icon: "/app-icons/all-tools.png"
  }
];

export default function AppFooter() {
  const { t } = useI18n();

  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <section className="site-footer-practice" aria-labelledby="footer-practice-title">
          <img
            className="site-footer-logo"
            src={assetPath("/common/main-page-assets/peraperalogo5.png")}
            alt=""
            loading="lazy"
            decoding="async"
          />
          <div className="site-footer-practice-copy">
            <p className="kicker">{t("footer.kicker")}</p>
            <h2 id="footer-practice-title">{t("footer.title")}</h2>
            <div className="site-footer-apps" aria-label={t("footer.linksLabel")}>
              {practiceLinks.map((link) => (
                <a key={link.href} href={link.href} target="_blank" rel="noreferrer">
                  <img src={assetPath(link.icon)} alt="" loading="lazy" decoding="async" />
                  <span>{link.label}</span>
                </a>
              ))}
            </div>
          </div>
        </section>

        <div className="site-footer-legal">
          <p>
            {t("footer.troublePrefix")}
            {" "}
            <a href="https://springsenglish.online/apps/" target="_blank" rel="noreferrer">{t("footer.here")}</a>
            {t("footer.troubleSuffix")}
          </p>
          <nav aria-label={t("footer.navLabel")}>
            <a href={assetPath("/info.html")}>{t("footer.about")}</a>
            <a href={assetPath("/feedback.html")}>{t("footer.feedback")}</a>
            <a href="https://pera-pera.org/" target="_blank" rel="noreferrer">pera-pera.org</a>
            <a href="https://sielpabooks.com/" target="_blank" rel="noreferrer">SielpA Books</a>
          </nav>
          <p>{t("footer.copyright")}</p>
        </div>
      </div>
    </footer>
  );
}
